<template>
  <div class="product-order-wrap">
    <div class="head-operate" v-show="isSearch || total != 0">
      <div>
        <vh-button
          v-if="isInWebinar"
          type="primary"
          size="medium"
          round
          @click="choseCoupon"
          v-preventReClick
        >
          {{ $t('lang.k_303001') }}
        </vh-button>
        <vh-button v-else type="primary" size="medium" round @click="addCoupon" v-preventReClick>
          {{ $t('lang.k_303002') }}
        </vh-button>

        <vh-button size="medium" round plain @click="allDelete" :disabled="!couponIds.length">
          {{ $t('lang.k_303003') }}
        </vh-button>
      </div>
      <div class="rightTool">
        <vh-select
          round
          size="medium"
          filterable
          v-model="searchParams.coupon_type"
          style="width: 100px"
          @change="getList('clearPage')"
          :placeholder="$t('lang.k_303004')"
          class="mr10 mb15"
        >
          <vh-option :label="$t('lang.k_303004')" value="" />
          <vh-option :label="$t('lang.k_303005')" :value="0" />
          <vh-option :label="$t('lang.k_303006')" :value="1" />
        </vh-select>
        <vh-input
          size="medium"
          round
          :maxlength="50"
          :placeholder="$t('lang.k_303007')"
          v-model="searchParams.keyword"
          class="input-with-select mr10 mb15"
          @keyup.enter.native="getList('clearPage')"
          clearable
          @clear="getList('clearPage')"
        >
          <i class="vh-icon-search vh-input__icon" slot="prefix" @click="getList('clearPage')"></i>
        </vh-input>
      </div>
    </div>
    <div v-if="!total && !isSearch" class="oh">
      <null-page v-if="isInWebinar" :nullType="'nullData'" :text="$t('lang.k_303008')">
        <vh-button type="primary" round @click="choseCoupon" v-preventReClick>
          {{ $t('lang.k_303001') }}
        </vh-button>
      </null-page>
      <null-page v-else :nullType="'nullData'" :text="$t('lang.k_303009')">
        <vh-button type="primary" round @click="addCoupon" v-preventReClick>
          {{ $t('lang.k_303002') }}
        </vh-button>
      </null-page>
    </div>
    <vh-table
      v-if="total || isSearch"
      :data="tableData"
      tooltip-effect="dark"
      @selection-change="handleTableCheckbox"
      style="width: 100%"
      ref="multipleTable"
      :header-cell-style="{ background: '#f7f7f7', color: '#666', height: '56px' }"
    >
      <vh-table-column type="selection" width="55" align="left" />
      <vh-table-column
        :label="$t('lang.k_303010')"
        prop="coupon_name"
        width="150"
        show-overflow-tooltip
      ></vh-table-column>
      <vh-table-column :label="$t('lang.k_303011')" minWidth="120">
        <template slot-scope="scope">
          <span>
            {{ scope.row.coupon_type | typeFilter }}
          </span>
        </template>
      </vh-table-column>
      <vh-table-column :label="$t('lang.k_303012')" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.coupon_type == 0">
            {{ $t('lang.k_303013') }}{{ scope.row.threshold_amount }}{{ $t('lang.k_303014')
            }}{{ scope.row.deduction_amount }}
          </span>
          <span v-if="scope.row.coupon_type == 1">
            {{ $t('lang.k_303015') }}{{ scope.row.deduction_amount }}
          </span>
        </template>
      </vh-table-column>
      <vh-table-column :label="$t('lang.k_303016')" width="130">
        <template slot-scope="scope">
          <span
            :class="{ highLight: scope.row.applicable_product_type != 0 }"
            @click="openGoodsList(scope.row)"
          >
            {{ scope.row.applicable_product_type | productFilter }}
            {{ scope.row.applicable_product_type != 0 ? scope.row.goods_num : '' }}
          </span>
        </template>
      </vh-table-column>
      <vh-table-column :label="$t('lang.k_303017')" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.validity_type == 0">
            <p>{{ $t('lang.k_303018') }}{{ scope.row.validity_start_time }}</p>
            <p>{{ $t('lang.k_303019') }}{{ scope.row.validity_end_time }}</p>
          </div>
          <span v-if="scope.row.validity_type == 1">
            {{ $t('lang.k_303020', [scope.row.validity_day]) }}
          </span>
        </template>
      </vh-table-column>
      <vh-table-column
        v-if="isInWebinar"
        :label="$t('lang.k_303022')"
        prop="received_sum"
        width="100"
      ></vh-table-column>
      <vh-table-column
        v-if="isInWebinar"
        :label="$t('lang.k_303023')"
        prop="used_sum"
        width="100"
      ></vh-table-column>
      <vh-table-column
        :label="$t('lang.k_303024')"
        v-if="!isInWebinar"
        width="160"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p class="link-item-operator">
            {{ scope.row.nick_name }}
          </p>
          <p class="link-item-operator">
            {{ scope.row.updated_at }}
          </p>
        </template>
      </vh-table-column>
      <vh-table-column :label="$t('lang.k_303025')" :width="isInWebinar ? 120 : 200" fixed="right">
        <template slot-scope="scope">
          <vh-button
            v-preventReClick
            v-if="!isInWebinar"
            class="btns"
            type="text"
            @click="toCopy(scope.row)"
          >
            {{ $t('lang.k_303026') }}
          </vh-button>
          <vh-button v-preventReClick class="btns" type="text" @click="toData(scope.row)">
            {{ $t('lang.k_303027') }}
          </vh-button>
          <vh-button
            v-preventReClick
            v-if="!isInWebinar"
            class="btns"
            type="text"
            @click="toEdit(scope.row)"
          >
            {{ $t('lang.k_303028') }}
          </vh-button>
          <vh-button v-preventReClick class="btns" type="text" @click="toDel(scope.row)">
            {{ $t('lang.k_303029') }}
          </vh-button>
        </template>
      </vh-table-column>
      <div slot="empty">
        <null-page
          :text="$t('lang.k_303030')"
          nullType="search"
          :height="100"
          v-if="!total"
        ></null-page>
      </div>
    </vh-table>
    <SPagination
      :total="total"
      :page-size="searchParams.page_size"
      :currentPage="searchParams.page"
      @current-change="currentChange"
      @size-change="sizeChange"
    ></SPagination>

    <!-- 弹框 -->
    <ChoseCoupon
      ref="choseCoupon"
      :needBind="true"
      @selected="selectedCoupon"
      source="account"
    ></ChoseCoupon>
    <Goods ref="goods" :couponId="curCouponId"></Goods>
  </div>
</template>

<script>
  import NullPage from '../../PlatformModule/Error/nullPage.vue';
  import { isEmbed } from '@/utils/utils';
  import Goods from './goods.vue';
  import ChoseCoupon from './choseCoupon.vue';
  import i18n from '@/common/i18n';

  const typeMap = [i18n.t('lang.k_303005'), i18n.t('lang.k_303006')];

  const productMap = [i18n.t('lang.k_303031'), i18n.t('lang.k_303032'), i18n.t('lang.k_303033')];

  export default {
    name: 'ProductCouponList',
    props: {
      isInWebinar: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    data() {
      return {
        isEmbed: isEmbed(),
        isSearch: false,
        searchParams: {
          page_size: 10,
          page: 1,
          coupon_type: '',
          keyword: ''
        },
        tableData: [], // 列表数据
        total: 0, // 列表总数
        curCouponId: '',
        couponIds: []
      };
    },
    components: {
      NullPage,
      Goods,
      ChoseCoupon
    },
    created() {
      this.getList('clearPage');
    },
    filters: {
      typeFilter(val) {
        return typeMap[val];
      },
      productFilter(val) {
        return productMap[val];
      }
    },
    methods: {
      // 复选框操作
      handleTableCheckbox(val) {
        this.couponIds = val.map(item => item.coupon_id);
      },
      setIsSearch() {
        for (let key in this.searchParams) {
          if (
            Object.prototype.hasOwnProperty.call(this.searchParams, key) &&
            !['page_size', 'page', 'webinar_id'].includes(key)
          ) {
            if (this.searchParams[key]) {
              this.isSearch = true;
              return;
            }
          }
          this.isSearch = false;
        }
      },
      getRequestParams() {
        return {
          ...this.searchParams,
          keyword: this.searchParams.keyword,
          coupon_type: this.searchParams.coupon_type,
          pos: (this.searchParams.page - 1) * this.searchParams.page_size,
          limit: this.searchParams.page_size
        };
      },
      getList(type) {
        if (type == 'clearPage') {
          this.searchParams.page = 1;
        }
        const params = this.getRequestParams();
        this.setIsSearch();

        let requestObj = '';
        if (this.isInWebinar) {
          params.webinar_id = this.$route.params.str;
          requestObj = 'getWebinarListCoupon';
        } else {
          requestObj = 'getListCoupon';
        }

        this.$fetch(requestObj, params, {
          'Content-Type': 'application/json'
        }).then(res => {
          if (res.code == 200 && res.data) {
            this.total = res.data.total;
            this.tableData = res.data.list;
          }
        });
      },
      toCopy(row) {
        this.$router.push(`${isEmbed() ? '/embed' : ''}/interactive/copyCoupon/${row.coupon_id}`);
      },
      toData(row) {
        if (this.isInWebinar) {
          this.$router.push(
            `${isEmbed() ? '/embed' : ''}/live/couponData/${this.$route.params.str}?couponId=${
              row.coupon_id
            }`
          );
        } else {
          this.$router.push(`${isEmbed() ? '/embed' : ''}/interactive/viewCoupon/${row.coupon_id}`);
        }
      },
      toEdit(row) {
        this.$router.push(`${isEmbed() ? '/embed' : ''}/interactive/editCoupon/${row.coupon_id}`);
      },
      toDel(rows) {
        this.deleteConfirm([rows.coupon_id]);
      },
      allDelete() {
        this.deleteConfirm(this.couponIds);
      },
      deleteConfirm(id) {
        this.$vhConfirm(
          this.$t('lang.k_303034'),
          this.$t('lang.k_303035'),

          {
            confirmButtonText: this.$t('lang.k_303036'),
            cancelButtonText: this.$t('lang.k_303037'),
            roundButton: true,
            customClass: 'zdy-message-box',
            lockScroll: false,
            cancelButtonClass: 'zdy-confirm-cancel'
          }
        ).then(() => {
          let params = {
            coupon_ids: id
          };
          let requestObj = '';
          if (this.isInWebinar) {
            params.webinar_id = this.$route.params.str;
            requestObj = 'batchWebinarDelCoupon';
          } else {
            requestObj = 'batchDelCoupon';
          }

          this.$fetch(requestObj, params, {
            'Content-Type': 'application/json'
          })
            .then(res => {
              if (res && res.code === 200) {
                this.$vhMessage({
                  message: `${this.$t('lang.k_303038')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
                // 刷新页面
                this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
                this.getList('clearPage');
                this.couponIds = [];
              }
            })
            .catch(res => {
              this.$vhMessage({
                message: res.msg || `${this.$t('lang.k_303039')}`,
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            });
        });
      },
      currentChange(val) {
        this.searchParams.page = val;
        this.getList();
      },
      sizeChange(val) {
        this.searchParams.page = 1;
        this.searchParams.page_size = val;
        this.getList();
      },
      addCoupon() {
        this.$router.push(`${isEmbed() ? '/embed' : ''}/interactive/addCoupon`);
      },
      openGoodsList(row) {
        console.log(row);
        if (row.applicable_product_type != 0) {
          this.curCouponId = parseInt(row.coupon_id + '');
          this.$nextTick(() => {
            this.$refs.goods.open();
          });
        }
      },
      choseCoupon() {
        if (this.total >= 200) {
          this.$vhMessage.error(this.$t('lang.k_303040'));
          return;
        }
        this.$refs.choseCoupon.open();
      },
      selectedCoupon(res) {
        console.log(res);
        this.getList('clearPage');
      }
    }
  };
</script>

<style lang="less" scoped>
  .product-order-wrap {
    min-height: 572px;
    .mr10 {
      margin-right: 10px;
    }
    .mb15 {
      margin-bottom: 15px;
    }
    .oh {
      overflow: hidden;
    }
    .head-operate {
      margin-bottom: 8px;
      display: flex;
      justify-content: space-between;
      .vh-button {
        height: 36px;
      }
      .rightTool {
        .input-with-select {
          width: 220px;
        }
      }
    }
    .highLight {
      color: #0a7ff5;
      cursor: pointer;
    }
    .products-dialog {
      .flexBox {
        display: flex;
        align-items: center;
        .name {
          margin-left: 10px;
        }
        .gift-cover {
          display: inline-block;
          width: 80px;
          min-width: 80px;
          height: 80px;
          // margin: 3px 0;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #e6e6e6;
          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }
      }
    }
    .link-item-operator {
      max-width: 130px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
</style>
